import { Key } from 'react';
import { AuthUser } from '../types/authUser';
import { persistedAtom } from '../utils/persistence';
import { selector } from 'recoil';
import { SafeGuardPanel } from '../types/safeGuard';
import { getPanelPage } from '../utils/panels';
import { Page } from '../types/core';
import { ALL_PAGES } from '../constants/app';
import { ApiError } from '@gorila-shared-ui/components/';

export const isLoggedInState = persistedAtom('app.loggedIn', false);

export const sidenavIsPinnedState = persistedAtom('app.sidenav.pinned', true);
export const sidenavSectionsState = persistedAtom<Key[]>('app.sidenav.sections', []);

export const pageState = persistedAtom<string>('app.page', '');

export const currentPageState = selector({
  key: 'app.pages.current',
  get: ({ get }) => {
    const currentPage = get(pageState);
    const allPages = get(allPagesState);
    return allPages.find((page) => page.id === currentPage) || allPages[0];
  },
});

export const authUserState = persistedAtom<AuthUser | undefined>('app.auth.user', undefined);
export const authErrorState = persistedAtom<ApiError>('app.auth.error', '');
export const authUserPanelPagesState = selector<Page[]>({
  key: 'app.pages.panels',
  get: ({ get }) => {
    const authUser = get(authUserState);
    if (!authUser) return [];
    try {
      const panels = JSON.parse(authUser.attributes['custom:granted_projects'])['gnp_kmseguros'];
      return panels.map((panel: SafeGuardPanel) => getPanelPage(panel));
    } catch (error) {
      return []
    }
  },
});
export const allPagesState = selector<Page[]>({
  key: 'app.pages.all',
  get: ({ get }) => {
    const panelPages = get(authUserPanelPagesState);
    if (!panelPages) return ALL_PAGES;
    return [...ALL_PAGES, ...panelPages];
  },
});





